import React, { Component } from 'react'
import ResourceItem from '../../models/resourceItem'

interface iProps {
    extraProps: ResourceItem[]
}

export default class clazzVideo extends Component<iProps> {
    render() {
        let {extraProps} = this.props
        return (
            <div>
                链接：
                {extraProps && !!(extraProps.length) && extraProps.map(item => item.playUrl)}
            </div>
        )
    }
}
